import {a}from'./chunk-GTTHVNDA.js';import {memo}from'react';import a$1 from'tailwind-styled-components';var d={none:"rounded-none",sm:"rounded-sm",normal:"rounded",md:"rounded-md",lg:"rounded-lg",xl:"rounded-xl",full:"rounded-full"},t=memo(a$1.img`
			${({isCover:r,rounded:e,className:m})=>a(r&&"object-cover",d[e!=null?e:"none"],m)}
			
		`);t.displayName="Image";var s=t;export{s as a};//# sourceMappingURL=chunk-YOL4HW4W.js.map
//# sourceMappingURL=chunk-YOL4HW4W.js.map